import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_SPECIFICATION_COLOR_TO_VARIANT_COLOR_ASSIGNMENT = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation SetSpecificationColorToVariantColorAssignment(
    $componentId: ID!
    $modelSpecificationColorId: ID!
    $productVariantColor: String!
  ) {
    setSpecificationColorToVariantColorAssignment(
      componentId: $componentId
      modelSpecificationColorId: $modelSpecificationColorId
      productVariantColor: $productVariantColor
    ) {
      component {
        id
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_SPECIFICATION_COLOR_TO_VARIANT_COLOR_ASSIGNMENT;
